import axios from 'axios';
import { BASE_URL } from '../components/Constant';

//link users with QBO details in user's accounting edit
function linkEmployee(payload) {
  const endpoint = BASE_URL + 'linkEmployee/linkEmployee';
  return axios.post(endpoint, payload);
}

//get linked employee details in accounting
function getLinkedEmployee(payload) {
  const endpoint = BASE_URL + 'linkEmployee/getLinkedEmployee';
  return axios.post(endpoint, payload);
}

//update linkEmployee
function updateLinkEmployee(payload) {
  const endpoint = BASE_URL + 'linkEmployee/updateLinkEmployee';
  return axios.put(endpoint, payload);
}

const linkEmployeeService = {
  linkEmployee,
  getLinkedEmployee,
  updateLinkEmployee
};

export default linkEmployeeService;
